import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import Header, { DispatchProps, StateProps } from 'components/global/application/Header';

import { setHeaderShowing } from 'redux/modules/display';
import {
    getAccessoriesMenu,
    load
} from 'redux/modules/shopify';

import { IRootState } from 'redux/root_reducer';

// set the menu collection id -- randomly set to 3
// temporary placement until we know more about where this will be managed...
const menuCollectionId = 1;

const mapStateToProps = ({ display, shopify }: IRootState): StateProps => {
    return {
        isHeaderShowing: display.headerShowing,
        isMobile: display.isMobile,
        menuProducts: shopify.menuProducts,
        menuProductsLoading: shopify.menuProductsLoading
    };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchProps => {
    return {
        getAccessoriesMenu: () => dispatch(getAccessoriesMenu(menuCollectionId)),
        loadShopifyProductsAndCart: () => dispatch<any>(load()),
        setHeaderShowing: (showing: boolean) => dispatch(setHeaderShowing(showing))
    };
};

export default withRouter(connect<StateProps, DispatchProps, RouteComponentProps<any>>(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/containers/global/application/Header.tsx